import { YoutubeChannelData } from '~/composer/composer/entities/Draft/types';

export const saveYoutubeDefaultsToStorage = (drafts) => {
  const youtubeDrafts = drafts.filter(
    (draft) => draft.id === 'youtube'
  );
  const youtubeDraft =
    youtubeDrafts && youtubeDrafts.length > 0 ? youtubeDrafts[0] : null;
  if (youtubeDraft) {
    const { channelData: { youtube } } = youtubeDraft;
    localStorage.setItem('youtube_defaults', JSON.stringify(youtube));
  }
}

export const getYoutubeDefaultsFromStorage = (): YoutubeChannelData | null => {
  const defaults = localStorage.getItem('youtube_defaults');
  if (defaults) {
    return JSON.parse(defaults);
  }
  return null;
}
